"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const shallow_1 = require("zustand/shallow");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const currenciesQuery_1 = require("../../../../queries/currenciesQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const zustandStore_1 = require("../../../../zustandStore");
const toggleSetting_1 = __importDefault(require("../../../molecules/setting/toggleSetting"));
const typeInputAdditionalSetting_1 = __importDefault(require("../../../molecules/setting/typeInputAdditionalSetting"));
const positiveIntegerPattern = /^[1-9]\d*$/;
const rightSideFeatureToggleList = (user) => [
    {
        featureKey: appConstants_1.companyFeaturesConstants.pauseVirtualCardCreation,
        label: strings_1.companySettingsOverviewStrings.FEATURE_PAUSE_VIRTUAL_CARD_CREATION,
        visible: true,
    },
    {
        featureKey: appConstants_1.companyFeaturesConstants.enableCompanyPeopleView,
        label: strings_1.companySettingsOverviewStrings.FEATURE_ENABLE_COMPANY_PEOPLE_VIEW,
        visible: user.isSupportAdmin,
    },
    {
        featureKey: appConstants_1.companyFeaturesConstants.enableGlobalization,
        label: strings_1.companySettingsOverviewStrings.FEATURE_ENABLE_GLOBALIZATION,
        visible: user.isSupportAdmin,
    },
];
const RightSideCompanyFeatures = () => {
    const { company, user, setCompanyFeature, setCompanyProperty, setIsCompanySettingsSaveBtnDisabled, companyErrors } = (0, zustandStore_1.useZustand)((0, shallow_1.useShallow)(state => ({
        setCompanyFeature: state.setCompanyFeature,
        setCompanyProperty: state.setCompanyProperty,
        setIsCompanySettingsSaveBtnDisabled: state.setIsCompanySettingsSaveBtnDisabled,
        company: state.company,
        user: state.user,
        companyErrors: state.company.companyErrors,
    })));
    const { data: teamId } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const currentTeamId = teamId && teamId.length > 0 ? teamId?.[0] : '';
    const { data: currencies, isLoading: isGetCurrenciesLoading } = (0, react_query_1.useQuery)((0, currenciesQuery_1.getCurrenciesQuery)(currentTeamId));
    const companyApprovalLimit = company?.properties?.companyApprovalLimit;
    const approvalLimitInputValue = lodash_1.default.isObject(companyApprovalLimit) && lodash_1.default.isEmpty(companyApprovalLimit) ? '' : company.properties.companyApprovalLimit;
    const isApprovalLimitValueValid = approvalLimitInputValue === '' ? true : positiveIntegerPattern.test(approvalLimitInputValue);
    const isError = Object.keys(appConstants_1.companyFeaturesConstants)?.find(key => companyErrors?.[appConstants_1.companyFeaturesConstants[key]] &&
        companyErrors[appConstants_1.companyFeaturesConstants[key]] !== '')?.length;
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { size: 6, children: (0, jsx_runtime_1.jsxs)(material_1.FormControl, { style: { paddingRight: 0 }, children: [rightSideFeatureToggleList(user).map(({ featureKey, label, visible = false }) => ((0, jsx_runtime_1.jsx)(toggleSetting_1.default, { name: featureKey, label: label, onValueChange: (event, value) => {
                        setCompanyFeature({ key: event.target.name, value });
                        setIsCompanySettingsSaveBtnDisabled(!!isError);
                    }, isChecked: company?.features?.[featureKey], style: { width: '100%' }, visible: visible }, featureKey))), (0, jsx_runtime_1.jsx)(typeInputAdditionalSetting_1.default, { dataTestId: "companyApprovalLimit-input", endAdornment: isGetCurrenciesLoading ? '...' : currencies?.[0] || 'N/A', name: appConstants_1.companyPropertiesConstants.companyApprovalLimit, value: approvalLimitInputValue, title: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP
                        ? strings_1.companySettingsOverviewStrings.FEATURE_AMEX_APPROVAL_LIMIT
                        : strings_1.companySettingsOverviewStrings.FEATURE_COMPANY_APPROVAL_LIMIT, onValueChange: (_name, value = '') => {
                        setCompanyProperty({ key: 'companyApprovalLimit', value });
                        const isDisabled = Boolean((value && positiveIntegerPattern.test(value)) || value === '');
                        setIsCompanySettingsSaveBtnDisabled(!!isError || !isDisabled);
                    }, textList: [], errorMessage: approvalLimitInputValue &&
                        !isApprovalLimitValueValid &&
                        (globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP
                            ? strings_1.teamInfoStrings.INVALID_NUMBER_TEXT
                            : strings_1.teamInfoStrings.HSBC_INVALID_NUMBER_TEXT), pattern: positiveIntegerPattern.source }), (0, jsx_runtime_1.jsxs)(material_1.List, { style: {
                        padding: '0 15px',
                        ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                            ? {
                                padding: '0 5px',
                            }
                            : {}),
                    }, children: [(0, jsx_runtime_1.jsx)(material_1.ListItem, { sx: [
                                {
                                    pb: 0.5,
                                    ml: 1,
                                    display: 'list-item',
                                },
                                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontSize: '12px',
                                        fontWeight: 300,
                                        color: '#000000',
                                    }
                                    : {},
                            ], children: strings_1.companySettingsOverviewStrings.FEATURE_COMPANY_APPROVAL_LIMIT_LABEL_1 }), (0, jsx_runtime_1.jsx)(material_1.ListItem, { sx: [
                                {
                                    pb: 0.5,
                                    ml: 1,
                                    display: 'list-item',
                                },
                                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontSize: '12px',
                                        fontWeight: 300,
                                        color: '#000000',
                                    }
                                    : {},
                            ], children: strings_1.companySettingsOverviewStrings.FEATURE_COMPANY_APPROVAL_LIMIT_LABEL_2 })] })] }) }));
};
exports.default = RightSideCompanyFeatures;
